import styled from '@emotion/styled';
import { Divider } from 'antd';
import { buyerNickMask } from 'services/channels/demo';
import QAPairImg from './assets/qaPair.svg';
import RobotIconRaw from 'components/RobotIcon';
import superviserSvg from './assets/superviser.svg';
import transferSvg from './assets/transfer.svg';
import { useQAPairOpenedWithKeepAlive } from 'hooks/business/im/useQAPair';

interface ConversationProfileProps {
  buyerNick: string;
  channel: string;
  region: string;
  botMark: boolean;
  superviseMark: boolean;
  transferMark: boolean;
  pauseAiReply?: boolean;
  existKnowledgePopup?: boolean;
}

export function ConversationProfile(props: ConversationProfileProps) {
  const {
    buyerNick,
    channel,
    region,
    botMark,
    superviseMark,
    transferMark,
    pauseAiReply,
    existKnowledgePopup,
  } = props;
  const qaPairOpenedWithKeepAlive = useQAPairOpenedWithKeepAlive();
  const qaPairEnable = qaPairOpenedWithKeepAlive && existKnowledgePopup;

  const isPaused = pauseAiReply || false;

  return (
    <Profile>
      <Nick>{buyerNickMask(buyerNick)}</Nick>
      {channel !== 'FACEBOOK' && region && region.toLowerCase() !== 'world' ? (
        <>
          <Divider type="vertical" className="!mx-2" />
          <StoreRegion>{region}</StoreRegion>
        </>
      ) : null}
      {qaPairEnable ? (
        <img src={QAPairImg} alt="qaPair" />
      ) : (
        (botMark || isPaused) && <RobotIcon status={isPaused ? 'paused' : 'idle'} />
      )}
      {superviseMark && <img src={superviserSvg} alt="superviser" />}
      {transferMark && <img src={transferSvg} alt="" />}
    </Profile>
  );
}

const Profile = styled.div`
  flex: 1 0 0;
  display: flex;
  overflow: hidden;
  align-items: center;

  img {
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
    margin-left: 6px;
  }
`;

const Ellipsis = styled.span`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const Nick = styled(Ellipsis)`
  font-size: 12px;
  color: #232426;
`;

const StoreRegion = styled.div`
  display: inline-block;
  flex: 0 0 auto;
  position: relative;
  font-size: 12px;
  color: #232426;
  text-align: right;
`;

const RobotIcon = styled(RobotIconRaw)`
  font-size: 18px;
`;
